import { Button, Grid, Message } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={1}>

			<Message
				titleText="Information message content"
				variant="info"
			/>
			<Message
				bulletPoints={["Information message content", "Information message content", "Information message content"]}
				titleText="Title for Information Message"
				variant="info"
			/>
			<Message
				description="Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content. Information message content."
				titleText="Title for Information Message"
				variant="info"
			/>
			<Message
				titleText="Information message content"
				variant="info"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>
			<Message
				bulletPoints={["Information message content", "Information message content", "Information message content"]}
				titleText="Information message content"
				variant="info"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>

		</CssColumnGrid>
	);
};

